import React, { Component } from "react";
import PropTypes from "prop-types";
import Layout from "../Layout";
import { Layout6 } from "../RowBox";
import { DivHover, DivHelp } from "./styled";

class Row6 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hover: false,
      hover1: false
    };
  }
  onHover = () => {
    this.setState({ hover: true });
  };
  onMouseOver = () => {
    this.setState({ hover: false });
  };
  render() {
    return (
      <DivHover
        onMouseLeave={this.onMouseOver.bind(this)}
        onMouseEnter={this.onHover.bind(this)}
      >
        <Layout {...this.props} type="Row" />
        {this.state.hover && <DivHelp>Row</DivHelp>}
      </DivHover>
    );
  }
}

Row6.propTypes = {
  childOf: PropTypes.string,
  values: PropTypes.object,
  cell: PropTypes.array,
  layout: PropTypes.func
};

Row6.defaultProps = {
  childOf: "Row",
  values: {
    parent: "Body",
    type: "Row",
    backgroundColor: "rgba(255,255,255,0)",
    backgroundImage: {
      url: "",
      urlMobile: "",
      desktop: {
        width: 0,
        height: 0
      },
      mobile: {
        width: 0,
        height: 0
      }
    },
    bgProps: {
      size: "cover",
      position: "center",
      repeat: "no-repeat",
      ratio: 1.2
    },
    align: "center",
    isBackgroundImage: false,
    padding: "0px",
    width: {
      type: "%",
      contentWidth: 100
    }
  },
  content: [
    {
      type: "Content",
      props: {
        values: {
          name: "Row6",
          parent: "Row",
          type: "Content",
          className: "col-xs-12 col-lg-3 col-md-3",
          column: 4,
          backgroundColorParent: "rgba(255,255,255,0)",
          backgroundColor: "rgba(255,255,255,0)",
          backgroundImage: {
            url: "",
            urlMobile: "",
            desktop: {
              width: 0,
              height: 0
            },
            mobile: {
              width: 0,
              height: 0
            }
          },
          bgProps: {
            size: "cover",
            position: "center",
            repeat: "no-repeat",
            ratio: 1.2
          },
          isBackgroundImage: false,
          padding: "0px",
          width: {
            type: "%",
            contentWidth: 100
          },
          alignment: {
            vertical: "center",
            horizontal: "center"
          }
        }
      },
      children: [],
      childOf: "Row"
    },
    {
      type: "Content",
      props: {
        values: {
          parent: "Row",
          type: "Content",
          className: "col-xs-12 col-lg-3 col-md-3",
          column: 4,
          backgroundColorParent: "rgba(255,255,255,0)",
          backgroundColor: "rgba(255,255,255,0)",
          backgroundImage: {
            url: "",
            urlMobile: "",
            desktop: {
              width: 0,
              height: 0
            },
            mobile: {
              width: 0,
              height: 0
            }
          },
          bgProps: {
            size: "cover",
            position: "center",
            repeat: "no-repeat",
            ratio: 1.2
          },
          isBackgroundImage: false,
          padding: "0px",
          width: {
            type: "%",
            contentWidth: 100
          },
          alignment: {
            vertical: "center",
            horizontal: "center"
          }
        }
      },
      children: [],
      childOf: "Row"
    },
    {
      type: "Content",
      props: {
        values: {
          parent: "Row",
          type: "Content",
          className: "col-xs-12 col-lg-3 col-md-3",
          column: 4,
          backgroundColorParent: "rgba(255,255,255,0)",
          backgroundColor: "rgba(255,255,255,0)",
          backgroundImage: {
            url: "",
            urlMobile: "",
            desktop: {
              width: 0,
              height: 0
            },
            mobile: {
              width: 0,
              height: 0
            }
          },
          bgProps: {
            size: "cover",
            position: "center",
            repeat: "no-repeat",
            ratio: 1.2
          },
          isBackgroundImage: false,
          padding: "0px",
          width: {
            type: "%",
            contentWidth: 100
          },
          alignment: {
            vertical: "center",
            horizontal: "center"
          }
        }
      },
      children: [],
      childOf: "Row"
    },
    {
      type: "Content",
      props: {
        values: {
          parent: "Row",
          type: "Content",
          className: "col-xs-12 col-lg-3 col-md-3",
          column: 4,
          backgroundColorParent: "rgba(255,255,255,0)",
          backgroundColor: "rgba(255,255,255,0)",
          backgroundImage: {
            url: "",
            urlMobile: "",
            desktop: {
              width: 0,
              height: 0
            },
            mobile: {
              width: 0,
              height: 0
            }
          },
          bgProps: {
            size: "cover",
            position: "center",
            repeat: "no-repeat",
            ratio: 1.2
          },
          isBackgroundImage: false,
          padding: "0px",
          width: {
            type: "%",
            contentWidth: 100
          },
          alignment: {
            vertical: "center",
            horizontal: "center"
          }
        }
      },
      children: [],
      childOf: "Row"
    }
  ],
  layout: Layout6
};
export default Row6;



// WEBPACK FOOTER //
// ./src/editor/layout/components/Row/Row6.js